import type { HelpFile } from '../../types/help'
import { IdentityManagerSectionTestIds } from '../../../testids/IdentityManagerSectionTestIds'

export const identityManagerSectionHelp: HelpFile = {
  docPage: '/docs/identity/identities',
  texts: {
    [IdentityManagerSectionTestIds.sectionManager]: 'The line manager(s) of this identity, resolved through the MANAGED_BY identity-to-identity relationship. Multi-employment-aware: each identity surfaces its own manager edge.',
    [IdentityManagerSectionTestIds.managerSectionEmpty]: 'No manager is assigned to this identity. Assign one through the relationship CRUD or the onboarding flow.',
    [IdentityManagerSectionTestIds.managerSectionError]: 'The manager edge could not be loaded. The section degrades independently of the rest of the page — retry to reload it.',
    [IdentityManagerSectionTestIds.managerSectionLoading]: 'The manager edge is loading.',
    [IdentityManagerSectionTestIds.linkManagerPrefix()]: 'Navigate to the manager identity\'s detail page.',
    [IdentityManagerSectionTestIds.managerDisplayNamePrefix()]: 'Identity-level display name of the manager. Per spec §7 this is never the manager\'s Party display name.',
    [IdentityManagerSectionTestIds.managerIdentityTypePrefix()]: 'Identity type of the manager (e.g. WORKFORCE).',
  },
}
